<hlm-alert-dialog [state]="isOpen() ? 'open' : 'closed'" (stateChanged)="onStateChange($event)">
  <div hlmAlertDialogContent *brnAlertDialogContent="let ctx" class="max-w-lg">
    <div hlmAlertDialogHeader>
      <h3 hlmAlertDialogTitle>{{ dialogTitle() }}</h3>
      <p hlmAlertDialogDescription>{{ dialogDescription() }}</p>
    </div>

    @if (hasRouteVariants()) {
      <div class="flex flex-col gap-2 py-2">
        @for (variant of routeVariants(); track variant.id) {
          <button
            type="button"
            hlmBtn
            variant="outline"
            class="justify-start h-auto py-3"
            (click)="runVariant(variant.id)"
          >
            <ng-icon name="lucidePlay" class="h-4 w-4" />
            <div class="flex flex-col items-start ml-2">
              <span class="font-medium">{{ variant.label }}</span>
              @if (variant.description) {
                <span class="text-xs text-muted-foreground">{{ variant.description }}</span>
              }
            </div>
          </button>
        }
      </div>
    } @else {
      <div class="py-6 text-center">
        <p class="text-sm text-muted-foreground">
          Stiamo lavorando per aggiungere guide dedicate a questa sezione. Torna a trovarci presto.
        </p>
      </div>
    }

    <div hlmAlertDialogFooter>
      <button hlmBtn variant="ghost" (click)="close()">Chiudi</button>
    </div>
  </div>
</hlm-alert-dialog>
